import React, { useState, useEffect, useRef } from 'react';

const TextColors = {
  dark: {
    token: 'text-gray-700',
    hex: '#4B5563'
  },
  light: {
    token: 'text-white',
    hex: '#FFFFFF'
  }
};

function luminance(color) {
  var rgb = color.map(function (c) {
    c /= 255; // to 0-1 range
    return c < 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });

  // https://en.wikipedia.org/wiki/Relative_luminance
  return (
    21.26 * rgb[0] + // red
    71.52 * rgb[1] + // green
    7.22 * rgb[2]
  ); // blue
}

function hexToRgb(hex) {
  const res = hex.match(/[a-f0-9]{2}/gi);

  return res && res.length === 3
    ? res.map(function (v) {
        return parseInt(v, 16);
      })
    : null;
}

export function contrastStyleColor(hexColor) {
  const y = luminance(hexToRgb(hexColor));

  // If luminance is closer to white return
  // black text.
  return y >= 50 ? TextColors.dark : TextColors.light;
}
